import Head from "next/head";
import { useRouter } from "next/router";
import { SidebarWrapper } from "@/components/layout/SidebarWrapper";
import { TemplateLibrary } from "@/components/template-library/TemplateLibrary";
import { TemplateLibraryBreadcrumbs } from "@/components/template-library/TemplateLibraryBreadcrumbs";
import { type DocumentType } from "@/utils";
import Card from "@/components/ui/design-system/Card";
import { Link } from "@/components/ui/design-system/Link";

function LibraryPage() {
  const router = useRouter();
  const group = router.query.group as string | undefined;
  const groupPath = group?.split(".") ?? [];

  const handleGroupPathChange = (newPath: string[]): void => {
    router.push({ query: { group: newPath.join(".") } });
  };

  const handleCloneSuccess = (docType: DocumentType) => {
    router.push(`/document-types/detail/?d=${docType.name}`);
  };

  return (
    <SidebarWrapper
      breadcrumbs={<TemplateLibraryBreadcrumbs groupPath={groupPath} />}
    >
      <Head>
        <title>Template library | Sensible</title>
      </Head>
      <Card elevation="1" className="!rounded-lg">
        {!groupPath.length && (
          <>
            <h1 className="text-2xl sm:text-4xl font-semibold mb-ds-3 sm:mb-ds-6">
              Template Library
            </h1>
            <div className="max-w-3xl space-y-4">
              <p>
                We have a number of document categories with pre-written parsing
                options to help you get started, or you can{" "}
                <Link href="/document-types/">create your own</Link>.
              </p>
              <p>
                Don't see a template that matches your need?{" "}
                <a href="mailto:support@sensible.so?subject=Configuration%20library%20suggestion">
                  Let us know
                </a>
                .
              </p>
            </div>
          </>
        )}
        <TemplateLibrary
          groupPath={groupPath}
          onGroupPathChange={handleGroupPathChange}
          onCloneSuccess={handleCloneSuccess}
        />
      </Card>
    </SidebarWrapper>
  );
}

export default LibraryPage;
